import * as types from '../mutation-types'
import { API } from '../../api'

export default {
    namespaced: true,
    state: {
        fromEmbedded: false,
        nickName: '',
        detailInfo: {},
        queryData: {}
    },
    getters: {},
    mutations: {},
    actions: {
        initEmbeddedDetailInfo({state}, params) {
            state.fromEmbedded = true;
            state.nickName = params.queryData.nickname;
            state.queryData = _.omit(params.queryData, ['id', 'nickname', 'from']);
            console.log('initEmbeddedDetailInfo------', state.queryData, params.queryData)
            
            API.getDetailInfo({
                id: params.queryData.id
            }, function(data){
                console.log('获取八字信息成功::::::', data);
                state.detailInfo = data;
                if(params.cb && typeof(params.cb) == 'function') {
                    params.cb(data);
                }
            });
        },
        resetData({state}) {
            state.fromEmbedded = false;
            state.nickName = '';
            state.detailInfo = {};
            state.queryData = {};
        }
    }
}